export default class Contact {
  public static readonly GET_INFO = '/contact/info';
  public static readonly UPDATE_CONTACT_INFO = '/contact/info';
}
